import React, { useState, useEffect, useRef, RefCallback, useMemo } from "react"
import { GatsbyImage } from "gatsby-plugin-image"

import { useInView } from "react-intersection-observer"
import { useFormat } from "../../../hooks/useFormat"

import "./stopMotion.scss"

const StopMotion = ({ frames, speed, slug, format }) => {
  const [currentFrame, setFrame] = useState(0)
  const [ref, inView, entry] = useInView({})
  const formatStyle = useFormat(format)
  const wrapper = useRef();

  useEffect(() => {
    if (inView) {
      const interval = setTimeout(() => {
        currentFrame < frames.length - 1
          ? setFrame(currentFrame => currentFrame + 1)
          : setFrame(0)
        wrapper.current.querySelectorAll('div').forEach(item => item.classList.remove('stmo-active'));
        wrapper.current.querySelector(`div:nth-child(${currentFrame + 1})`).classList.add('stmo-active');
      }, speed)
      return () => clearTimeout(interval)
    }
  }, [currentFrame, inView])

  const stopMotionTransition = useMemo(() => {
    const transitionSpeed = speed < 1000 ? speed / 2 : 500

    return {
      transition: `opacity ${transitionSpeed}ms ease-in-out ${transitionSpeed/2}ms`,
    }
  }, [speed])

  return (
    <div
      className={`stop-motion hero ${format.shadow ? "shadow" : ""}`}
      ref={ref}
      style={formatStyle}
    >
      <div className="frame-wrapper" ref={wrapper}>
        {frames.map((element, index) => {
          if (element.localFile?.childImageSharp?.gatsbyImageData !== undefined) {
            return (

              <GatsbyImage
                objectFit="cover"
                image={element.localFile?.childImageSharp?.gatsbyImageData}
                alt=""
                // imgStyle={{display: index === currentFrame ? "block" : "none" }}
                key={index}
                className={index === 0 ? "stmo-active" : "none"}
                style={stopMotionTransition}

              />
            )
          } else {
            return (
              <img
                src={element.sourceUrl}
                style={{
                  transition: 0,
                  opacity: index === currentFrame ? 1 : 0,
                }}
                key={index}
              />
            )
          }
        })}
      </div>
    </div>
  )
}

export default StopMotion
